// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { color, hideElementOnPrint } from "@west/XDL/Utilities";
import { css } from "styled-components";

promotionCodeFormStyles.applyButton = {
    variant: "primary",
    css: css`
        position: absolute;
        min-height: 28px;
        min-width: 71px;
        right: 3px;
        top: 3px;

        &,
        span {
            line-height: 12px;
            font-size: 11px;
            font-weight: bold;
        }
        padding: 0 20px;
    `,
};

promotionCodeFormStyles.applySuccessText = {
    color: "success",
    weight: "bold",
    css: css`
        margin-top: 10px;
    `,
};

promotionCodeFormStyles.promotionCodeGridItem = {
    width: [12, 12, 12, 8, 8],
    css: css`
        margin-top: 10px;
    `,
};

promotionCodeFormStyles.applyPromotionGridItem = {
    width: [3, 3, 3, 3, 3],
    css: css`
        width: 100%;
        display: flex;
        align-items: flex-start;
        &&& {
            margin-top: 23px;
        }
    `,
};

promotionCodeFormStyles.form = {
    css: css`
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin: 4px 0;

        ${hideElementOnPrint}
    `,
};

promotionCodeFormStyles.promotionCodeTextField = {
    cssOverrides: {
        inputSelect: css`
            &,
            &:focus {
                padding-right: 100px;
            }
            &::placeholder {
                color: ${color("common.ui4")};
            }
        `,
    },
};

promotionCodeFormStyles.removeCodeTag = {
    typographyProps: {
        ellipsis: true,
        lineHeight: "18px",
        css: css`
            width: 100%;
            text-align: left;
            margin: 0;
        `,
    },
};

promotionCodeFormStyles.removeCodeGridItem = {
    width: [12, 12, 12, 12, 12],
    css: css`
        flex-wrap: wrap;
        row-gap: 8px;
    `,
};

promotionCodeFormStyles.removeCodesLink = { };
